document.querySelectorAll(".employee-drop-area").forEach((dropArea) => {
    const fileInput = dropArea.querySelector("input[type='file']");
    const formElement = dropArea.closest(".form-element");
    const uploadedBox = formElement.querySelector(".file-uploaded");
    const uploadedFileName = uploadedBox.querySelector("p");
  
    // Prevent default drag behaviors
    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  
    // Highlight drop area
    ["dragenter", "dragover"].forEach((eventName) => {
      dropArea.addEventListener(eventName, () =>
        dropArea.classList.add("highlight")
      );
    });
  
    ["dragleave", "drop"].forEach((eventName) => {
      dropArea.addEventListener(eventName, () =>
        dropArea.classList.remove("highlight")
      );
    });
  
    // Trigger file input when area clicked
    dropArea.addEventListener("click", () => fileInput.click());
  
    // Handle file drop
    dropArea.addEventListener("drop", (e) => {
      const files = e.dataTransfer.files;
      handleFiles(files);
    });
  
    // Handle manual file selection
    fileInput.addEventListener("change", (e) => {
      handleFiles(e.target.files);
    });
  
    function handleFiles(files) {
      if (!files || files.length === 0) return;
      const file = files[0];
      uploadedFileName.textContent = file.name;
      uploadedBox.classList.remove("d-none");
      if (uploadedBox) {
        const uploadContainer = uploadedBox.closest(".form-element--upload");
        if (uploadContainer) {
          const dataFile = uploadContainer.getAttribute("data-file");
          document.getElementById(`uploaded-${dataFile}`).value = 1;
        }
      }
    }
  });
  
  // Handle remove file
  document.querySelectorAll(".btn--remove").forEach((btn) => {
    btn.addEventListener("click", function () {
      const formElement = this.closest(".form-element");
      const uploadedBox = formElement.querySelector(".file-uploaded");
      const fileInput = formElement.querySelector("input[type='file']");

      uploadedBox.classList.add("d-none");
      uploadedBox.querySelector("p").textContent = "";
      fileInput.value = "";
      const resume_cv = this.getAttribute("data-upload");
      if( resume_cv == 'resume' ) { 
        document.getElementById("uploaded-resume").value = 0;
        document.getElementById("upload-resume").setAttribute("data-resume", "");
      } else {
        document.getElementById("uploaded-cv").value = 0;
        document.getElementById("cover-letter").setAttribute("data-cv", "");
      }
    });
  });